/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { Dropdown, Input, InputGroup } from 'rsuite';

const GlobalSearch = (props) => {
	const {
		dropDownOptions = [],
		searchDropDown = true,
		suffix = {},
		setSearchValue = () => { },
		setSelectedValue = () => { },
		handleValue = () => { },
		pageType = '',
		isRefresh = false,
		placeholderText = 'Search...',
		width = '200px',
		initialValue = '',
	} = props;

	const [selectedOption, setSelectedOption] = useState(dropDownOptions[0]);
	const [search, setSearch] = useState('');
	const isFirstInput = useRef(true);
	const hasSetInitialValue = useRef(false);
	const hasSetDropDownOption = useRef(false);

	useEffect(() => {
		if (initialValue && !hasSetInitialValue.current) {
			setSearch(initialValue);
			setSelectedValue({
				...selectedOption,
				searchValue: initialValue,
			});
			hasSetInitialValue.current = true;
		}
	}, [initialValue]);

	useEffect(() => {
		if (dropDownOptions.length > 0 && !hasSetDropDownOption.current) {
			setSelectedOption(dropDownOptions[0]);
			hasSetDropDownOption.current = true;
		}
	}, [dropDownOptions]);

	const handleInputValue = (value) => {
		const trimmedValue = value.trim();

		if (isFirstInput.current) {
			isFirstInput.current = false;
		}

		setSearch(value);
		setSearchValue(value);

		const keyPressed = !isFirstInput.current && trimmedValue === '';

		setSelectedValue({
			...selectedOption,
			searchValue: value,
			keyPress: keyPressed,
		});
	};

	useEffect(() => {
		if (isRefresh) {
			setSearch('');
			setSelectedValue({
				...selectedOption,
				searchValue: search,
			});
			hasSetInitialValue.current = false;
		}
	}, [isRefresh]);

	useEffect(() => {
		setSelectedOption(dropDownOptions[0]);
	}, [pageType]);

	return (
		<div className='flex gap-2 my-2 align-center justify-center w-full'>
			{searchDropDown && (
				<Dropdown
					title={selectedOption?.label}
					appearance="default"
					menuStyle={{ width: width, zIndex: 9999 }}

				>
					{dropDownOptions.map((option) => (
						<Dropdown.Item
							key={option.value}
							disabled={option?.disable}
							className={`${option?.disable ? 'cursor-not-allowed' : ''}`}
							onClick={
								!option?.disable
									? () => {
										setSelectedOption(option);
										setSelectedValue({ ...option, searchValue: search });
									}
									: undefined
							}
						>
							{option.label}
						</Dropdown.Item>
					))}
				</Dropdown>
			)}
			<InputGroup
				style={{
					border: '1px solid #ddd',
					borderRadius: '50px',
					overflow: 'hidden',
					width: '100%',
					boxShadow: '0px 1px 1px 1px #F1F5F9'
				}}
			>
				{selectedOption && suffix[selectedOption.value] && suffix[selectedOption.value].name && (
					<InputGroup.Addon
						style={{
							backgroundColor: '#f7f7f7',
							border: 'none',
							margin: '5px 14px',
							borderRadius: '5px',
						}}
					>
						{suffix[selectedOption.value].name}
					</InputGroup.Addon>
				)}
				<Input
					value={search}
					onChange={handleInputValue}
					placeholder={selectedOption?.placeholder ?? placeholderText}
					style={{
						border: 'none',
						padding: '8px 12px',
					}}
					{...(selectedOption?.getData ? { onKeyDown: handleValue } : {})}
				/>
			</InputGroup>
		</div>
	);
};

export default GlobalSearch;